import { useOwnedStation } from '@app/core/stations/hooks/useOwnedStation';
import {
  socialExportListConnectionsByStationQueryOptions,
  webAppGetFragmentSocialUploadsByFragmentIdQueryOptions,
  webAppListEditsVideoEditorEditsQueryOptions,
} from '@mi-front/api-v2';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useFragment } from '../hooks/useFragment';

/**
 * Preloads data required by secondary fragment tabs to keep tab switches responsive.
 * Social connections are only prefetched for owned stations (publish is owner-only).
 */
export function FragmentViewPreload() {
  const { fragment } = useFragment();
  const queryClient = useQueryClient();
  const canPublish = !!useOwnedStation(fragment.stationId);

  useEffect(() => {
    const { id: fragmentId, stationId } = fragment;

    const editsOptions = webAppListEditsVideoEditorEditsQueryOptions({ fragmentId });
    void queryClient.prefetchQuery(editsOptions);

    const socialUploadsOptions = webAppGetFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId);
    void queryClient.prefetchQuery(socialUploadsOptions);

    if (canPublish) {
      const socialConnectionsOptions = socialExportListConnectionsByStationQueryOptions(stationId);
      void queryClient.prefetchQuery(socialConnectionsOptions);
    }
  }, [fragment.id, fragment.stationId, queryClient, canPublish]);

  return null;
}
